import Promise from 'bluebird';
import api from '../../api';
import worldMap from '../map';
import environment from '../../environment';
import { translate } from '../tools/translate';
import { CONFIG } from '../../../config';

const LayerInfo = (name) => require('../../info').get(name);

const streetView = (() => {
    let visible = false;
    let locateMarker = null;
    let pinMarker = null;

    const clearLocate = () => {
        if (locateMarker && worldMap.hasLayer(locateMarker))
            worldMap.removeLayer(locateMarker);
    };

    const clearPin = () => {
        if (pinMarker && worldMap.get(pinMarker))
            worldMap.removeLayer(pinMarker);
    };

    const _createPoint = () => {
        LayerInfo('CreatePoint').addMarker(locateMarker.getLatLng());
        return api.general.get.geocode({
            lat: locateMarker.getLatLng().lat,
            lng: locateMarker.getLatLng().lng
        }).then(loc => {
            loc.coordinates.lat = locateMarker.getLatLng().lat;
            loc.coordinates.lng = locateMarker.getLatLng().lng;
            LayerInfo('CreatePoint').updateByGeocode(loc);
        });
    };

    const _createPin = () => {
        LayerInfo('CreatePoint').addMarker(pinMarker.getLatLng());
        return api.general.get.geocode({
            lat: pinMarker.getLatLng().lat,
            lng: pinMarker.getLatLng().lng
        }).then(loc => {
            loc.coordinates.lat = pinMarker.getLatLng().lat;
            loc.coordinates.lng = pinMarker.getLatLng().lng;
            LayerInfo('CreatePoint').updateByGeocode(loc);
        });
    };

    const _createButton = options => {
        const content = $('#image-container');
        const button = $(`
      <div class="pull-${(options.side || 'right')}">
        <button class="btn btn-default">${options.text}</button>
      </div>
    `);
        content.find('.action-bar').append(button);
        if (options.click) {
            button.find('button').on('click', () => options.click());
        }

        if (options.autoclick) {
            button.find('button').trigger('click');
        }
    };

    const thumbnailStreetView = (container, latlng) => {
        if (!latlng) {
            return;
        }

        let autostart = false;
        const _processImage = () =>
            new Promise((resolve, reject) => {
                const image = document.createElement('img');
                autostart = true;
                image.src = `https://maps.googleapis.com/maps/api/streetview?size=${worldMap.getThumbImageSize()}&location=${latlng.lat},${latlng.lng}&sensor=false&key=${CONFIG.GOOGLE_MAPS_API_KEY}`;
                resolve(image);
            });

        return _processImage().then(image => {
            const a = document.createElement('a');
            a.href = '#';
            $(a).append(image);
            $(a).on('click', e => {
                e.preventDefault();
                show(latlng, true, autostart);
            });

            $(container).html(a);
        });
    };

    const thumbnail = (container, latlng, imageUrl) => {
        if (!latlng) {
            return;
        }

        let autostart = false;

        const _processImage = () =>
            new Promise((resolve, reject) => {
                const image = document.createElement('img');
                if (imageUrl) {
                    const verifyImageUrl = new Image();
                    verifyImageUrl.onload = () => {
                        autostart = false;
                        image.src = imageUrl;
                        resolve(image);
                    };



                    verifyImageUrl.onerror = () => {
                        autostart = true;
                        image.src = `https://maps.googleapis.com/maps/api/streetview?size=${worldMap.getThumbImageSize()}&location=${latlng.lat},${latlng.lng}&sensor=false&key=${CONFIG.GOOGLE_MAPS_API_KEY}`;
                        resolve(image);
                    };

                    verifyImageUrl.src = imageUrl;
                } else {
                    autostart = true;
                    image.src = `https://maps.googleapis.com/maps/api/streetview?size=${worldMap.getThumbImageSize()}&location=${latlng.lat},${latlng.lng}&sensor=false&key=${CONFIG.GOOGLE_MAPS_API_KEY}`;
                    resolve(image);
                }
            });

        return _processImage().then(image => {
            const a = document.createElement('a');
            a.href = '#';
            a.className = 'store-thumbnail-link';
            $(a).on('click', e => {
                e.preventDefault();
                show(latlng, true, autostart);
            });

            $(container).html(a);
            $(container).append(image);
        });
    };

    const locate = latlng => {
        clearLocate();

        const icon = L.icon({
            iconUrl: `${environment.get('IMAGES_HOST')}/pin_address_found.png`,
            iconSize: [50, 64],
            iconAnchor: [25, 60]
        });
        locateMarker = L.marker(latlng, { icon }).addTo(worldMap.get());
        locateMarker.on('click', _createPoint);
    };

    const createPin = latlng => {
        if (pinMarker && worldMap.hasLayer(pinMarker)) {
            clearPin();
        }

        const icon = L.icon({
            iconUrl: `${environment.get('IMAGES_HOST')}/pin_locale.png`,
            iconSize: [30, 40],
        });
        pinMarker = L.marker(latlng, { icon }).addTo(worldMap.get());
        pinMarker.on('click', _createPin);
    };

    const show = (latlng, place = false, autostart = false) => {
        if (visible || !latlng) {
            return;
        }

        latlng = new google.maps.LatLng(latlng.lat, latlng.lng);

        const _showView = streetViewPanoramaData => {
            visible = true;

            const content = $('#image-container');
            if (content.is(':visible')) {
                content.find('.cancel').trigger('click');
            }

            content.fadeIn(300);
            content.append($(`
                <div class="image-content">
                  <div class="street-view"></div>
                <div>
                <div class="action-bar"> </div>
            `));

            _createButton({
                text: translate('Action.Close'),
                side: 'left',
                click() {
                    visible = false;
                    content.empty().hide();
                }
            });

            _createButton({
                text: translate('Action.Locate'),
                click() {
                    visible = false;
                    content.empty().hide();
                    const position = panorama.location.latLng;
                    return locate(L.latLng(position.lat(), position.lng()));
                }
            });

            const position = streetViewPanoramaData.location.latLng;
            const heading = google.maps.geometry.spherical.computeHeading(position, latlng);
            const panoramaOptions = {
                position: latlng,
                addressControl: false,
                imageDateControl: true,
                // linksControl: false
                // panControl: false
                zoomControl: false,
                pov: {
                    zoom: 1,
                    heading,
                    pitch: 0
                },
                zoom: 1
            };
            const panorama = new google.maps.StreetViewPanorama(content.find('.street-view')[0], panoramaOptions);
            panorama.setVisible(true);
        };

        const streetViewService = new google.maps.StreetViewService();
        const STREETVIEW_MAX_DISTANCE = 100;
        streetViewService.getPanoramaByLocation(latlng, STREETVIEW_MAX_DISTANCE, (streetViewPanoramaData, status) => {
            if (status === google.maps.StreetViewStatus.OK) {
                if (place) {
                    _createButton({
                        text: translate('Action.Navigate'),
                        click() {
                            _showView(streetViewPanoramaData);
                        },
                        autoclick: autostart
                    });
                } else {
                    _showView(streetViewPanoramaData);
                }
            } else {
                alert(translate('Error.StreetViewUnavailable'));
            }
        });
    };

    const setVisibility = value => {
        visible = value;
    };


    const hide = () => {
        const content = $('#image-container');
        visible = false;
        content.empty().hide();
    };

    return {
        clearLocate,
        clearPin,
        createPin,
        locate,
        show,
        hide,
        thumbnail,
        thumbnailStreetView,
        visible: setVisibility
    };
})();

export default streetView;



// WEBPACK FOOTER //
// ./src/scripts/core/map/streetview.js